import React, { useEffect, useState } from "react";
import { useDebouncedValue } from "@/hooks/useDebouncedValue";
import SearchInput from "@/components/SearchInput/SearchInput";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ProcessWheelStatusFilter } from "../../api/getProcessWheels/types";

interface ProcessWheelFiltersProps {
  searchTerm: string;
  status: ProcessWheelStatusFilter;
  onSearchChange: (value: string) => void;
  onStatusChange: (status: ProcessWheelStatusFilter) => void;
}

const ProcessWheelFilters: React.FC<ProcessWheelFiltersProps> = ({
  searchTerm,
  status,
  onSearchChange,
  onStatusChange,
}) => {
  const [searchInput, setSearchInput] = useState(searchTerm);
  const debouncedSearch = useDebouncedValue(searchInput, 500);

  useEffect(() => {
    if (debouncedSearch !== searchTerm) {
      onSearchChange(debouncedSearch);
    }
  }, [debouncedSearch, searchTerm, onSearchChange]);

  return (
    <div className="mb-4 flex items-center gap-3">
      <SearchInput
        className="max-w-md"
        onChange={setSearchInput}
        placeholder="Search by name"
        value={searchInput}
      />
      <Select
        onValueChange={(value) =>
          onStatusChange(value as ProcessWheelStatusFilter)
        }
        value={status}
      >
        <SelectTrigger className="w-[140px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All</SelectItem>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="inactive">Inactive</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default ProcessWheelFilters;
